import {GoogleMap, Marker, useJsApiLoader} from '@react-google-maps/api';
import React from 'react';

const containerStyle = {
    width: '100%',
    height: '100%'
};

interface MapProps {
    lat: number,
    long: number,
    zoom: number,
    showMarker: boolean
}

export default function MGoogleMap(props: MapProps) {
    // Loads the map using API KEY
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyBp79fnrSHgUF4LwfKrpOJKDdNpLQOKHe8'
    });

    const mapCentre = {
        lat: props.lat,
        lng: props.long
    }

    const pinPos = {
        lat: props.lat,
        lng: props.long
    }

    // This returns while map is being loaded
    if (!isLoaded)
        return <div>Loading...</div>

    return (
        <GoogleMap
            zoom={18}
            center={mapCentre}
            mapContainerStyle={containerStyle}
        >
            {props.showMarker && <Marker position={pinPos} />}
        </GoogleMap>
    )
}